export default __webpack_public_path__ + "static/media/star.65799a4e.svg";